<template>
  <div class="flex justify-end">
    <LSButton variant="outline" type="danger" size="small" @click="isOpen = true">
      <template #icon>
        <TrashIcon />
      </template>
    </LSButton>
  </div>
  <DialogModal :show="isOpen" @close-modal="$emit('close')" :title="'Möchten Sie die Vorlagenvariable löschen?'">
    <div class="flex space-x-4">
      <LSButton type="secondary" @click="isOpen = false" variant="outline">Nicht löschen</LSButton>
      <LSButton type="danger" @click="removeTemplateVariable">Vorlagenvariable löschen</LSButton>
    </div>
  </DialogModal>
</template>

<script setup lang="ts">
import type { TemplateVariable } from '@/questionnaire/types'
import { ref } from 'vue'
import { useAdminStore } from '@/admin/adminStore'
import LSButton from '@/components/LSButton.vue'
import TrashIcon from '@/assets/icons/24/trash.svg?component'
import DialogModal from '@/components/DialogModal.vue'
import { errorNotification } from '@/utils/notifications'

const props = defineProps<{
  templateVariable: TemplateVariable
}>()
const emit = defineEmits<{
  click: []
  close: []
}>()

const adminStore = useAdminStore()
const isOpen = ref(false)

const removeTemplateVariable = () => {
  return adminStore
    .removeTemplateVariable(props.templateVariable.id)
    .then(() => {
      emit('click')
      isOpen.value = false
    })
    .catch(err => {
      if (err.response.data.errors) {
        errorNotification(err.response.data.errors.base)
        alert(err.response.data.errors.base[0])
      }
    })
}
</script>
